export class AsyncDecorator {
    // TODO: these should be either functions and named "timeSuckingTick" etc
    // or they should be rewritten as es6 classes
    public static timeSuckingTick(delayInMilliseconds: number) {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            property.value = function (...args: any[]) {
                return new Promise((resolve) => {
                    setTimeout(() => resolve(null), delayInMilliseconds);
                }).then(() => fn.apply(this, args));
            };
        };
    }

    public static chaosTick(minDelay: number, maxDelay: number) {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            property.value = function (...args: any[]) {
                const delayInMilliseconds =
                    Math.floor(Math.random() * (maxDelay - minDelay)) +
                    minDelay;
                return new Promise((resolve) => {
                    setTimeout(() => resolve(null), delayInMilliseconds);
                }).then(() => fn.apply(this, args));
            };
        };
    }

    // NOTE: This should not be attached to an api call directly. Debouncing
    // should be done on input listeners, not the api directly. Use lodash-decorators
    // @debounce decorator for this
    public static onlyFireAfterDelayInBeingCalled(delayInMilliseconds: number) {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            let def: any;
            let myTimer: any;
            property.value = function (...args: any[]) {
                def = new deferred();
                if (myTimer) {
                    clearTimeout(myTimer);
                }
                myTimer = window.setTimeout(() => {
                    // can I just do "resolve(fn.apply(this, args));"
                    fn.apply(this, args).then((x: any) => {
                        def.resolve(x);
                    });
                    // have to pass on error also
                }, delayInMilliseconds);

                return def.promise;
            };
        };
    }

    public static waitForFolders() {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            property.value = function (...args: any[]) {
                // const folderService = appInjector().get(FoldersDataService);
                // return folderService.foldersPromise.then(() => {
                return fn.apply(this, args);
                // });
            };
        };
    }

    public static temporaryMark(markingFn: Function, time: number) {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            let timeOut: number;
            property.value = function (...args: any[]) {
                markingFn.apply(this, [true]);
                if (timeOut) {
                    clearTimeout(timeOut);
                }
                timeOut = window.setTimeout(
                    () => markingFn.apply(this, [false]),
                    time
                );
                return fn.apply(this, args);
            };
        };
    }
}

export function wait(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

// I like the Deferred construct - modified from MSDN
export class deferred {
    /* A method to resolve the associated Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} value: This value is used to resolve the promise
     * If the value is a Promise then the associated promise assumes the state
     * of Promise passed as value.
     */
    resolve: any = null;
    /* A method to reject the assocaited Promise with the value passed.
     * If the promise is already settled it does nothing.
     *
     * @param {anything} reason: The reason for the rejection of the Promise.
     * Generally its an Error object. If however a Promise is passed, then the Promise
     * itself will be the reason for rejection no matter the state of the Promise.
     */
    reject: any = null;
    /* A newly created Pomise object.
     * Initially in pending state.
     */
    promise: Promise<any>;

    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        Object.freeze(this);
    }
}

export type OnlySuccessSuccess = {
    tag: number;
    value: any;
    status: string;
};
type OnlySuccessError = {
    tag: number;
    error: any;
    status: string;
};
export type OnlySuccessReturn = OnlySuccessSuccess | OnlySuccessError;

export const onlySuccess = function (
    promise: Promise<any>,
    tag: number
): Promise<OnlySuccessReturn> {
    return promise.then(
        (value) => ({
            tag,
            value,
            status: 'fulfilled'
        }),
        (error) => ({
            tag,
            error,
            status: 'rejected'
        })
    );
};
